module.exports = __webpack_public_path__ + "img/calendar2-day.b61ee5c9.svg";